import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import "./robot.css";
import "./header.css";
import { ethers } from "ethers";
import ReactPlayer from 'react-player';
import { useMediaQuery } from 'react-responsive';
import {instructions, responseBackground, bodies, glasses, hats, stickers, contracts, soundeffects } from "../tools/effects";
import { fisherYatesShuffle, cacheImage, preloadImages, formatNumber, removeThousands, truncateAddress } from '../tools/utils';
import { client, decimals, injectDate, dateExtractor, network,
  StreamText, parseResponse, brainAddresses, brainNFTaddresses, contractsBrain, contractsBRAINS, ethersProviders, contractEthersBrainNFTs, 
  maxDialogueReads} from "./brain";
import { createThirdwebClient, getContract, sendTransaction, readContract, prepareContractCall, prepareEvent, numberToBytes} from "thirdweb";
import { useActiveAccount, useReadContract, useActiveWallet, useActiveWalletChain, useDisconnect,
  useSwitchActiveWalletChain, useSendTransaction, useWalletBalance, useContractEvents } from "thirdweb/react";
import { FaFireAlt } from "react-icons/fa";
// import { RateLimiter } from 'rate-limiter-flexible';
import axios from "axios";
import { HiOutlineX } from "react-icons/hi";
import { FaRegCircleXmark } from "react-icons/fa6";
import { TiWarning } from "react-icons/ti";
import { IoArrowBackCircleSharp, IoArrowForwardCircleSharp } from "react-icons/io5";
import { defineChain } from "thirdweb/chains";
import { useSelector } from 'react-redux';
import { selectBlockchain, selectNetworkIndex, chains } from '../redux/reducers/networkReducer';


// Media Screen Resolution *************************************************************************************************
const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 769 });
  return isDesktop ? children : null;
};

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return isMobile ? children : null;
};

let account, blockchain, networkIndex, brainAddress, brainNFTAddress, ethersProvider, contractEthersBrainNFT, 
isMintparameter, isMint, isResponse, isReading, isIndexed;

function Robot() {
  account = useActiveAccount();
  blockchain = useSelector(selectBlockchain);
  networkIndex = useSelector(selectNetworkIndex);
  brainAddress = brainAddresses[networkIndex];
  brainNFTAddress = brainNFTaddresses[networkIndex];
  ethersProvider = ethersProviders[networkIndex];
  contractEthersBrainNFT = contractEthersBrainNFTs[networkIndex];

  const [currentBody, setCurrentBody] = useState(bodies[0]);
  const [currentGlasses, setCurrentGlasses] = useState(glasses[0]);
  const [currentHat, setCurrentHat] = useState(hats[0]);
  const [currentSticker, setCurrentSticker] = useState(stickers[0]);
  const [loading, setLoading] = useState(false);
  const [esthetics, setEsthetics] = useState(false);
  const [submitText, setSubmitText] = useState('...thinking...');
  const [nameText, setNameText] = useState('');
  const [isApproving, setIsApproving] = useState(false);
  const [isMinting, setIsMinting] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [accountBal, setAccountBal] = useState(null);
  const [mint, setMint] = useState(false);
  const [mintLog, setMintLog] = useState(false);
  const [mintValues, setMintValues] = useState([]);
  const [counter, setCounter] = useState(null);
  const { mutate: sendTransaction, data: transactionResult, error: txError } = useSendTransaction();
  
  const [instruction, setInstruction] = useState(instructions.Default);
  const [request, setRequest] = useState('');
  const [response, setResponse] = useState(null);
  const [stream, setStream] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [backgroundImage, setBackgroundImage] = useState(responseBackground.OutlayInsight);
  const [backgroundImageMobile, setBackgroundImageMobile] = useState(responseBackground.OutlayInsightMobile);
  const [numb3rs, setNumb3rs] = useState({first: 0, second: 0, third: 0, fourth: 0, fifth: 0, sixth: 0, seventh: 0, eighth: 0, ninth: 0, last: 0});
  const textareaRef = useRef(null);
  const [currentNFT, setCurrentNFT] = useState(null);
  const [currentClass, setCurrentClass] = useState('');
  const [currentModel, setCurrentModel] = useState('Sonar Pro');
  const [currentModule, setCurrentModule] = useState('Perplexity');
  const [currentTopic, setCurrentTopic] = useState('');
  const [currentResponse, setCurrentResponse] = useState(null);
  const [dialogues, setDialogues] = useState(null);
  const [prevPost, setPrevPost] = useState({prev: 0, post: 0});
  const [decodedArray, setDecodedArray] = useState(null);
  const [recodedMap, setRecodedMap] = useState(null);
  const [history, setHistory] = useState(null);
  const [sessionHistory, setSessionHistory] = useState({ dialogues: [], tokenId: 0, modules: '', models: '', class: '', topic: [], tmap: [] });
  const [conversations, setConversations] = useState([]);
  const [like, setLike] = useState(false);
  const [putter, setPutter] = useState(false);
  const [isWriting, setIsWriting] = useState(false);
  const [isEffectPlaying, setIsEffectPlaying] = useState(false);
  const [soundEffectUrl, setSoundEffectUrl] = useState(null);
  const [volumeLevel, setVolumeLevel] = useState(0.1);
  const [viewHistory, setViewHistory] = useState(false);
  const [dateStamp, setDateStamp] = useState([]);
  const [desktopBenchmark, setDesktopBenchmark] = useState(0);
  const [mobileBenchmark, setMobileBenchmark] = useState(0);
  const [historicalDialogue, setHistoricalDialogue] = useState(null);
  const [historyIndex, setHistoryIndex] = useState(0);    
  const [trigger, setTrigger] = useState(false);  
  const isMobile = useMediaQuery({ maxWidth: 767 });  
  const [parameters, setParameters] = useState({desktopMax: 10, mobileMax: 14, delay_const: 4000, maxDialogueReads: 50});
  const [isPrepping, setIsPrepping] = useState(false);
  const [assistance, setAssistance] = useState(null);
  const [modeSelect, setModeSelect] = useState({deepseek: 0, openai: 0, anthropic: 0, perplexity: 1})
  const [activeIndex, setActiveIndex] = useState(0);

  const fallBackToPerplexity = () => {
    sendMessage("...Anthropic Unavailable. Querying fallback AI", 30000);    
      setModeSelect({deepseek: 0, openai: 0, anthropic: 0, perplexity: 1});
      setActiveIndex(3);
    playSonar();
  }

  const fallBackToAnthropic = () => {
    sendMessage("...OpenAI Unavailable. Querying fallback AI", 30000);    
      setModeSelect({deepseek: 0, openai: 0, anthropic: 1, perplexity: 0});
      setActiveIndex(2);
    playSonar();
  }

  const fallBackToOpenAI = () => {
    sendMessage("...Deepseek Unavailable. Querying fallback AI", 30000);    
      setModeSelect({deepseek: 0, openai: 1, anthropic: 0, perplexity: 0});
      setActiveIndex(2);
    playSonar();
  }

  const fallBackToDeepseek = () => {
    sendMessage("...Perplexity Unavailable. Querying fallback AI", 30000);    
      setModeSelect({deepseek: 1, openai: 0, anthropic: 0, perplexity: 0});
      setActiveIndex(1);
    playSonar();
  }

  const handleMode = (index) => {
    if (index === activeIndex) return;
    setActiveIndex(index);
    if (index === 0) {
      setModeSelect({deepseek: 0, openai: 0, anthropic: 0, perplexity: 1});
      setCurrentModule('Perplexity');
    } else if (index === 1) {
      setModeSelect({deepseek: 1, openai: 0, anthropic: 0, perplexity: 0});
      setCurrentModule('Deepseek');
    } else if (index === 2) {
      setModeSelect({deepseek: 0, openai: 1, anthropic: 0, perplexity: 0});
      setCurrentModule('Openai');
    } else if (index === 3) {
      setModeSelect({deepseek: 0, openai: 0, anthropic: 1, perplexity: 0});
      setCurrentModule('Anthropic');
    }
  };

  function modeSelector () {
    return (
      <div className="modeSelector">
        {[0, 1, 2, 3].map((index) => (
          <div
            key={index}
            className={`childSelector ${activeIndex === index ? 'active' : ''}`}
            onClick={() => handleMode(index)}
          >
            <div className="ball" />
          </div>
        ))}
      </div>
    );
  }

  function arrangeFallback () {
    if (activeIndex === 0) {  
      return "Deepseek";
    } else if (activeIndex === 1) {
      return "OpenAI";
    } else if (activeIndex === 2) {
      return "Anthropic";
    } else return "Perplexity"
  }

  function resetState() {
    setLoading(false); setEsthetics(false); setSubmitText('...thinking...');
    setNameText(''); setIsApproving(false); setIsMinting(false);
    setAccountBal(null); setMint(false); setMintLog(false);
    setMintValues([]); setCounter(null); setInstruction(instructions.Default);
    setResponse(null); setStream(null); setIsLoading(false);
    setError(''); setCurrentNFT(null); setCurrentResponse(null);
    setDialogues(null); setPrevPost({prev: 0, post: 0}); setDecodedArray(null);
    setRecodedMap(null); setHistory(null); 
    setSessionHistory({ dialogues: [], tokenId: 0, modules: '', models: '', class: '', topic: [], tmap: [] });
    setConversations([]); setLike(false); setPutter(false); setIsWriting(false);
    setViewHistory(false); setDateStamp([]); setDesktopBenchmark(0); setMobileBenchmark(0);
    setHistoricalDialogue(null); setHistoryIndex(0); setTrigger(false); setAssistance(null);
  }

// get B.R.A.I.N contract
let contractBrain = contractsBrain[networkIndex];

let contractBRAINS = contractsBRAINS[networkIndex];
  
  let put;

  const handleViewHistory = () => {
    if (currentNFT > 0) {
      setViewHistory(true);
      setResponse('');
      setEsthetics(false);
      setLoading(false); 
    } else {
      sendMessage('Initiate a session to begin.', 5000);
      setTimeout(() => {
        handleMintSession();
      }, 5000);
    }
  }
  
  const playSoundEffect = (effect) => {
    setSoundEffectUrl(effect);
    setIsEffectPlaying(true);
  };

  const playSonar = () => {
    playSoundEffect(soundeffects.Sonar);
  }
  
  const stopSoundEffect = () => {
    setIsEffectPlaying(false);
  };

  async function concatenateMaps(documented, prev, post) {
    // Skip concatenation if both prev and post are 0 (i.e., "0-0")
    if (prev === 0 && post === 0) {
        return documented; // Return the documented string as is
    }

    const concatenated = documented + `${prev}-${post},`;
    return concatenated;
  }

  const hideLikes = () => {
    setLike(); 
    setPutter();
  }

  const handleLikes = () => {
    put = false;
    setLike();
    setPutter(true);
    appendToSessionHistory(currentResponse);
  }

  function handlePutter() {
    if (put) return;
    submitEventHistory();
    setPutter();
    put = true;
  }

  // Function to append new topic and conversation
  const appendToSessionHistory = async() => {
    const Dialogues = [...dialogues, currentResponse];
    const freshDialogues = [...conversations, currentResponse];
    // Regenerate the essay with the updated dialogues
    const updatedEssay = await generateEssay(Dialogues);
    setDialogues(Dialogues);
    console.log('updatedDialogues:', Dialogues);
    setConversations(freshDialogues);
    console.log('fresh conversations:', freshDialogues)
    setSessionHistory({ dialogues: freshDialogues, tokenId: currentNFT, modules: currentModule, models: currentModel, class: currentClass, topic: currentTopic, tmap: recodedMap });
    setHistory(updatedEssay);
    console.log('Updated essay:', updatedEssay);
  };

  const generateEssay = async (dialogue) => {
    if (dialogue.length === 0) return ""; // Return empty string if the array is empty

    let essay = "";
    let entryNumber = 1; // Track the entry number separately to skip empty entries

    for (let i = 0; i < dialogue.length; i++) {
        const entry = dialogue[i];

        // Skip falsy values (empty strings, null, undefined, etc.) and strings with only whitespace
        if (typeof entry === 'string' && entry.trim() !== "") {
            // Add a leading number and a paragraph break after each entry
            essay += `HELPFUL AI RESPONSE ${entryNumber} AND ASSOCIATED INFORMATION PROVIDED: ${entry}\n\n`;
            entryNumber++; // Increment the entry number only for valid entries
        }
    }

    return essay.trim(); // Trim any trailing spaces or newlines
  };

  const submitEventHistory = async () => {
    setIsWriting(true);
    try {
    // submit Dialogue
      const transaction = prepareContractCall({
        contract: contractBRAINS, 
        method: "function putDialogues(string[] calldata _dialogues, uint256 _tokenId, string _modules, string _models, string _class, string _topic, string _tmap) returns(uint256)", 
        params: [sessionHistory.dialogues, sessionHistory.tokenId, sessionHistory.modules, sessionHistory.models, sessionHistory.class, sessionHistory.topic, sessionHistory.tmap],
      });

      sendTransaction(transaction); 
    } catch (error) {
      console.log('error writing dialogues to blockchain', error);
    }
  };

  function lengthChecker(arr, _maxDialogueReads) {
    if (!Array.isArray(arr) || _maxDialogueReads < 1) return [];

    let result = [];
    for (let i = 0; i < arr.length; i += _maxDialogueReads) {
        result.push(arr.slice(i, i + _maxDialogueReads));
    }
    return result;
  }

  async function stringToArrayDecode(str) {
    if (!str) return [];
    
    return str.split(',')
        .map(item => item.trim())  // Trim whitespace from each entry
        .filter(item => item !== '')  // Remove empty entries from trailing commas
        .flatMap(item => {
            if (item.includes('-')) {
                const [start, end] = item.split('-').map(Number);
                if (!isNaN(start) && !isNaN(end) && start < end) {
                    return Array.from({ length: end - start }, (_, i) => start + i);
                }
            } else {
                const num = Number(item);
                if (!isNaN(num)) return num;
            }
            return [];
        });
}


  async function arrayToStringRecode(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return '';

    arr.sort((a, b) => a - b); // Ensure numbers are sorted
    let result = [];
    let start = arr[0];
    let end = start;

    for (let i = 1; i < arr.length; i++) {
        if (arr[i] === end + 1) {
            end = arr[i]; // Continue the sequence
        } else {
            result.push(`${start}-${end + 1}`);
            start = end = arr[i];
        }
    }

    // Push the final range
    result.push(`${start}-${end + 1}`);

    return result.join(',') + ',';  // Ensure a trailing comma
  }

  async function fetchPreviousDialogue() {
    const signer = ethersProvider.getSigner(account.address);
    const contractWithSigner = contractEthersBrainNFT.connect(signer);

     // console.log('Fetching previous dialogue for NFT...');
    let mapArray = [], topic, prev, post, dialogue = [];
    // Fetch dialogue maps
     // console.log('current NFT:', currentNFT, 'type:', typeof(currentNFT));
    
    try {
      // const call1 = await readContract({
      //   contract: contractBRAINS,
      //   method: "function pullBrain(uint256 _tokenId) view returns ((string topic, string tmap, uint256 prev, uint256 post)[])",
      //   params: [currentNFT],
      // });

      const call1 = await contractWithSigner.pullBrain(currentNFT);
      // console.log('Fetched history:', call1);  
      
      const documented = call1[0].tmap;
      topic = call1[0].topic;
      prev = Number(call1[0].prev);
      post = Number(call1[0].post);

      setPrevPost({prev: prev, post: post});
       // console.log('Fetched prev and post:', prev, post);

      // concatenate & map documented with undocumented dialogues
      const map = await concatenateMaps(documented, prev, post);

       // console.log('concatenated documentation:', map);
      
      const decodedArray = await stringToArrayDecode(map);
      setRecodedMap(map);
      setDecodedArray(decodedArray);
       // console.log('decoded Array from blockchain:', decodedArray);

      if (decodedArray.length > parameters.maxDialogueReads) {
        mapArray = lengthChecker(decodedArray, parameters.maxDialogueReads);
         // console.log('array in smaller chucks:', mapArray);
      } else {
        mapArray.push(decodedArray);
         // console.log('array without chucks:', mapArray);
      }; 

    } catch (err) {
      console.log( 'Error fetching tmap',err);
      return;
    }

    // Fetch previous dialogue from maps
    if (mapArray.length > 0) {
      let entry;
      try {
        for (let i = 0; i < mapArray.length; i++) {
          entry = mapArray[i];
          const call2 = await contractWithSigner.fetchDialogues(entry, currentNFT);
          // console.log('Fetched dialogue:', call2);

          dialogue.push(...call2);
        }
        
        setDialogues(dialogue); 
        const extractedDates = dateExtractor(dialogue);
        setDateStamp(extractedDates);
        // console.log('datestamps:', extractedDates);            
        // console.log('onchain dialogues:', dialogue);
        const essay = await generateEssay(dialogue);
        setHistory(essay);
        // console.log('generated essay:', essay);
        
      } catch (err) {
        console.log('Error fetching dialogue history', err);
        return;
      }
    }
  }

  // Adjust textarea dynamically
  if (textareaRef.current) {
    textareaRef.current.style.height = "auto"; // Reset height to recalculate
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }

  function sendMessage(message, timeframe) {    
    setSubmitText(message);
    setLoading(true);
    setTimeout(() => {setLoading(false);}, timeframe);
  }

  function sendEstheticMessage(_messages, timeframe) {
    playSonar(); 
    let messages = [..._messages];
    for (let s = 0; s < messages.length; s++) {
      if (!response) {
        setEsthetics(true);
        const message = messages[s]; 
        setTimeout(() => {setSubmitText(message)}, timeframe * s);
          if (s === messages.length - 1) {
            setTimeout(() => {setSubmitText('Calibrating B.R.A.I.N response...')}, timeframe * messages.length);
            setTimeout(() => {setEsthetics(false)}, timeframe * (messages.length + 1));
          }
        }  
      }
  }

  function runDelayMessage() {
    setTimeout(() => {
      setSubmitText('v.0.1 still in development...');
      setLoading(true);
    }, 5010);
  }

  let responderBackground = {
    backgroundImage: `url(${backgroundImage})`
  };

  let responderMobileBackground = {
    backgroundImage: `url(${backgroundImageMobile})`
  };

  const responder = () => {
    return (
      <>   
        <HiOutlineX className="responder-close-button" onClick={closeResponse}/>
          <div className={`responses ${like ? 'like' : '' } ${putter ? 'putter' : '' }`}>
            <div align="right">
              <FaRegCircleXmark className="responder-close-button-micro" onClick={hideLikes}/>
            </div>
            {like && !putter && 
              <div onClick={handleLikes}>
                <img src={require("../assets/images/love_white_bkg.gif")} className="loveGif"/>   
                <div>
                  Like this response? <br />
                  Let's archive it for you. <br /> 
                  Click to archive.
                </div>
              </div>
            }
            {putter && !like && 
              <div>            
                <img src={require("../assets/images/love_white_bkg.gif")} className="loveGif"/><br />   
                <span className="class1" style={{ color: 'whitesmoke'}}>Save onchain? </span><br />
                <button className="button-plaid" onClick={handlePutter}>Send Now</button>
                <button className="button-plaid" onClick={hideLikes}>Send Later</button>
                <br />
                <div className="caution">All conversations are prone to loss if you fail to save them onchain at the end of your session.</div> 
                <div className="onchain-disclaimer">Onchain Disclaimer: AI conversations saved onchain are as private as they can be on a public blockchain. Though sufficiently hidden from unauthorized view from the casual observer, there are still ways to obtain access to this information from a much more technical observer and that is by blockchain data scrapping, which is a very expensive and laborious way to do so. ZKProof implementation can futher close this gap. We hope to offer that when feasible for even more privacy.</div>
              </div>
            }
          </div>
        <div className="numb3rs1 title waveanimator" onClick={handleNumb3rs1}>{numb3rs.first}{numb3rs.second}{numb3rs.third}{numb3rs.fourth}{numb3rs.fifth}{numb3rs.last}
          <br /><span className="insights">INSIGHTS</span> 
        </div>
        <div className="numb3rs3 title waveanimator" onClick={handleNumb3rs3}>
          <span className="disclaimer">DISCLAIMER</span><br /> 
          {numb3rs.sixth}{numb3rs.eighth}{numb3rs.last}

        </div>
        <div className="numb3rs5 title waveanimator" onClick={handleNumb3rs5}>{numb3rs.last}{numb3rs.sixth}{numb3rs.seventh}{numb3rs.eighth}{numb3rs.ninth}{numb3rs.second}{numb3rs.third}
          <br /><span className="advice">QUICK ADVICE</span> 
        </div>
          {loading ? 
            <div className="brain-placeholder centerMass">
              <LoadingDock />
            </div>
          :
            <div className="main-display textemphasis">
              <StreamText text={stream} delay_const={parameters.delay_const} />
              </div>
          }
        <div className="numb3rs2 title waveanimator" onClick={handleNumb3rs2}>{numb3rs.ninth}{numb3rs.fifth}{numb3rs.eighth}{numb3rs.fourth}{numb3rs.sixth}{numb3rs.third}
          <br /><span className="contacts">CONTACTS</span>
        </div>
        <div className="numb3rs4 title waveanimator" onClick={handleNumb3rs4}>{numb3rs.second}{numb3rs.first}{numb3rs.second}
          <br /><span className="list">NEXT</span>
          <br /><span className="list">STEPS</span>
        </div>
        <div className="numb3rs6 title waveanimator" onClick={handleNumb3rs6}>{numb3rs.seventh}{numb3rs.fourth}{numb3rs.last}{numb3rs.last}{numb3rs.ninth}{numb3rs.third}{numb3rs.fifth}
          <br /><span className="actions">ACTIONABLE</span> <br />
          <span className="actions">INTELLIGENCE</span>
        </div>
      </>
    );
  }

  // let totalDesktopBenchmarks = Math.max(1, Math.ceil(dialogues.length / parameters.desktopMax));
  // let totalMobileBenchmarks = Math.max(1, Math.ceil(dialogues.length / parameters.mobileMax));

  const renderDateList = () => {
    if (dialogues.length === 0) return null;
  
    // Calculate the start and end indices for desktop and mobile
    const desktopStartIndex = desktopBenchmark * parameters.desktopMax;
    const desktopEndIndex = Math.min(desktopStartIndex + parameters.desktopMax, dialogues.length);
  
    const mobileStartIndex = mobileBenchmark * parameters.mobileMax;
    const mobileEndIndex = Math.min(mobileStartIndex + parameters.mobileMax, dialogues.length);
  
    // Determine which indices to render based on the view (desktop or mobile)

    const startIndex = isMobile ? mobileStartIndex : desktopStartIndex;
    const endIndex = isMobile ? mobileEndIndex : desktopEndIndex;
  
    // Slice the dialogues array to get the subset to render
    const visibleDialogues = dialogues.slice(startIndex, endIndex);
  
    return visibleDialogues.map((dialogue, index) => (
      <div key={startIndex + index}>
        <div onClick={() => { setHistoryIndex(startIndex + index) }} className="dateList">
          {dateStamp.length > 0 && <>{startIndex + index}{isMobile ? <span style={{opacity: '0.4'}}> | </span>: ' 🧠 '}</>}
        </div>
      </div>
    ));
  };

  const handleNextDatelist = () => {
    if (isMobile) {
      const maxBenchmark = Math.ceil(dialogues.length / parameters.mobileMax) - 1;
      if (mobileBenchmark < maxBenchmark) {
        setMobileBenchmark(mobileBenchmark + 1);
      }
    } else {
      const maxBenchmark = Math.ceil(dialogues.length / parameters.desktopMax) - 1;
      if (desktopBenchmark < maxBenchmark) {
        setDesktopBenchmark(desktopBenchmark + 1);
      }
    }
  };
  
  const handlePreviousDatelist = () => {
    if (isMobile) {
      if (mobileBenchmark > 0) {
        setMobileBenchmark(mobileBenchmark - 1);
      }
    } else {
      if (desktopBenchmark > 0) {
        setDesktopBenchmark(desktopBenchmark - 1);
      }
    }
  };

  const historia = () => {
    return (
      <>   
        <HiOutlineX className="responder-close-button" onClick={closeHistoria} style={{color: 'lime', borderColor: 'lime'}}/>
        <div className="dateHeader">
          <IoArrowBackCircleSharp onClick={handlePreviousDatelist} style={{cursor: 'pointer'}}/>
          {renderDateList()}
          <IoArrowForwardCircleSharp onClick={handleNextDatelist} style={{cursor: 'pointer'}}/>
        </div>
        <div className={`dateTitle dateTitle${viewHistory}`}>The B.R.A.I.N on <span style={{color: 'wheat'}}>{dateStamp[historyIndex]}</span> </div>
        <div className="numb3rs1 title waveanimator" onClick={handleNumb3rs1}>{numb3rs.first}{numb3rs.second}{numb3rs.third}{numb3rs.fourth}{numb3rs.fifth}{numb3rs.last}
          <br /><span className="insights">INSIGHTS</span> 
        </div>
        <div className="numb3rs3 title waveanimator" onClick={handleNumb3rs3}>
          <span className="disclaimer">DISCLAIMER</span><br /> 
          {numb3rs.sixth}{numb3rs.eighth}{numb3rs.last}

        </div>
        <div className="numb3rs5 title waveanimator" onClick={handleNumb3rs5}>{numb3rs.last}{numb3rs.sixth}{numb3rs.seventh}{numb3rs.eighth}{numb3rs.ninth}{numb3rs.second}{numb3rs.third}
          <br /><span className="advice">QUICK ADVICE</span> 
        </div>
          {loading ? 
            <div className="brain-placeholder centerMass">
              <LoadingDock />
            </div>
          :
            <div className="main-display textemphasis">
              {stream.length > 0 ? 
                <>
                  {isPrepping && <img src={require("../assets/images/progressbar.gif")} className="progressbar"/>}
                  <StreamText text={stream} />
                </> 
                : 
                <StreamText text={'No Information for this at this time.'} />
                }          
            </div>
          }
        <div className="numb3rs2 title waveanimator" onClick={handleNumb3rs2}>{numb3rs.ninth}{numb3rs.fifth}{numb3rs.eighth}{numb3rs.fourth}{numb3rs.sixth}{numb3rs.third}
          <br /><span className="contacts">CONTACTS</span>
        </div>
        <div className="numb3rs4 title waveanimator" onClick={handleNumb3rs4}>{numb3rs.second}{numb3rs.first}{numb3rs.second}
          <br /><span className="list">NEXT</span>
          <br /><span className="list">STEPS</span>
        </div>
        <div className="numb3rs6 title waveanimator" onClick={handleNumb3rs6}>{numb3rs.seventh}{numb3rs.fourth}{numb3rs.last}{numb3rs.last}{numb3rs.ninth}{numb3rs.third}{numb3rs.fifth}
          <br /><span className="actions">ACTIONABLE</span> <br />
          <span className="actions">INTELLIGENCE</span>
        </div>
      </>
    );
  }

  // Create a rate limiter instance
  // const rateLimiter = new RateLimiter({
  //   points: 1, // Number of requests allowed
  //   duration: 10, // Time window in seconds
  // });

  async function perplexityAI(_assistance) {
    let assistance = _assistance;
    try {
      const response = await axios.post('https://daemon.brainonsonic.xyz/perplexity/generate', {
        instruction,
        assistance,
        request
      });
  
      if (response.status === 200) {
        const result = response.data.message;
        const parsedResponse = await parseResponse(result);
        setResponse(parsedResponse);
        setStream(parsedResponse.insight);
        const injectedResult = injectDate(result);
        // console.log(injectedResult);
        setCurrentResponse(injectedResult);
        setCurrentModule('Perplexity');
        setCurrentModel('Sonar Pro');
        // console.log(parsedResponse);
        // stamp Essay;
      } else if (response.status === 400 || response.status === 403 || response.status === 429 || response.status === 500) {
        // console.log('Perplexity API failed. Switching to Deepseek.');
        // openAI(_assistance);  // Fallback to OpenAI
        fallBackToDeepseek();
      } else {
        console.log(response.status);
      }
    } catch (err) {
      console.log('Perplexity failed to generate response:', err);
      fallBackToDeepseek();
    }
  }

  async function deepseekAI(_assistance) {
    let assistance = _assistance;
    try {
      const response = await axios.post('https://daemon.brainonsonic.xyz/deepseek/generate', {
        instruction,
        assistance,
        request
      });
  
      if (response.status === 200) {
        const result = response.data.message;
        const parsedResponse = await parseResponse(result);
        setResponse(parsedResponse);
        setStream(parsedResponse.insight);
        const injectedResult = injectDate(result);
        // console.log(injectedResult);
        setCurrentResponse(injectedResult);
        setCurrentModule('Deepseek');
        setCurrentModel('V3');
        // console.log(parsedResponse);
        // stamp Essay;
      } else if (response.status === 400 || response.status === 403 || response.status === 429 || response.status === 500) {
        // console.log('Deepseek API failed. Switching to OpenAI.');
        // openAI(_assistance);  // Fallback to OpenAI
        fallBackToOpenAI();
      } else {
        console.log(response.status);
      }
    } catch (err) {
      console.log('Deepseek failed to generate response:', err);
      fallBackToOpenAI();
    }
  }

  async function openAI (_assistance) {
    let assistance = _assistance;
    try {
      const response = await axios.post('https://daemon.brainonsonic.xyz/openai/generate', {
        instruction,
        assistance,
        request
      });
  
      if (response.status === 200) {
        const result = response.data.message;
        const parsedResponse = await parseResponse(result);
        setResponse(parsedResponse);
        setStream(parsedResponse.insight);
        setCurrentResponse(result);
        setCurrentModule('OpenAI');
        setCurrentModel('GPT-4o');
        // console.log(parsedResponse);
        const injectedResult = injectDate(result);
        // console.log(injectedResult);
      } else if (response.status === 400 || response.status === 403 || response.status === 429 || response.status === 500) {
        // console.log('Open API failed. Switching to Anthropic.'); 
        fallBackToAnthropic();
      } else {
        console.log(response.status);
      }

   } catch (err) {
     console.log('OpenAI Failed to generate response.');
      fallBackToAnthropic(); // Fallbacking to Anthropic
   }
  }

  async function anthropicAI(_assistance) {
    let assistance = _assistance;
    try {
      const response = await axios.post('https://daemon.brainonsonic.xyz/anthropic/generate', {
        instruction,
        assistance,
        request
      });
  
      if (response.status === 200) {
        const result = response.data.message;
        const parsedResponse = await parseResponse(result);
        setResponse(parsedResponse);
        setStream(parsedResponse.insight);
        const injectedResult = injectDate(result);
        // console.log(injectedResult);
        setCurrentResponse(injectedResult);
        setCurrentModule('Anthropic');
        setCurrentModel('Claude-Sonnet-v7');
        // console.log(parsedResponse);
        // stamp Essay;
      } else if (response.status === 400 || response.status === 403 || response.status === 429 || response.status === 500) {
        // console.log('Anthropic API failed. Switching to Perplexity.');
        fallBackToPerplexity();
      } else {
        console.log(response.status);
      }
    } catch (err) {
      console.log('Anthropic failed to generate response:', err);
      fallBackToPerplexity(); // Fallbacking to Perplexity
    }
  }

  const runQuery = async() => {
    console.log('running runQuery...');
    let assistance;
    setIsLoading(true);
    setResponse('');  
    setError('');  
    const futureModules = ['Spinning up modules...','Querying Deepseek...', 'Querying OpenAI...', 'Shadowing Kimi...', 'Shadowing Grok...', 'Shadowing Qwen...','Processing and trimming...'];
    assistance = `The following have been previous AI responses to this user. This is provided for context and your reference. Use all relevant information to improve your next response. If it presents as an empty string, null, or [object object], treat these as nothing of note. Do not use any previous responses provided by the AI outside this user curated conversational history: ${history}`;
     // assistance = 'Previous responses from AI';
    setTimeout(() => {
    sendEstheticMessage(futureModules,6000);
    }, 7000);

    setAssistance(assistance);
  };   

  async function mintBrain(_mintfee, _name) {
    sendMessage('Minting...', 5000);
    // console.log('minting with values: ', _mintfee, _name);
    setIsMinting(true);
    const fee = Number(ethers.utils.formatEther(_mintfee.toString()));
    const mintfee = fee * decimals;
    const transaction = prepareContractCall({
      contract: contractBRAINS, 
      method: "function mint(string _name) payable", 
      params: [_name],
      value: mintfee,
    });
 
    sendTransaction(transaction);
  }
  
  
  async function handleSession () {
    if (currentNFT > 0) {
          sendMessage('Initiating session...',3000);
          
          if (!mintLog) {
            setMintLog(true);
          }     

          setTrigger(true);
          setTimeout(() => {
            setTrigger(false);
          },4000);
        // runDelayMessage();
    } else {
      handleMintSession();
    }
  }

  async function fetchBrainNFT() {
    let balance, nft;
    try {
      const call1 = await readContract({
        contract: contractBRAINS,
        method: "function balanceOf(address owner) view returns (uint256)",
        params: [account.address],
      });
      
      balance = Number(call1?.toString());

      if (balance) {
        console.log('session found');       
          const call2 = await readContract({
            contract: contractBRAINS,
            method: "function tokenOfOwnerByIndex(address owner, uint256 index) view returns (uint256)",
            params: [account.address, 0],
          });
        
        nft = Number(call2?.toString());
          
        if (nft > 0) {
          setCurrentNFT(nft);
        }

      } 
      return balance;
    } catch (err) {
      console.log('error fetching session nft', err);
      sendMessage('Error fetching session nft.', 5000);
      return;
    }
  }

  function MintParameter() {
    let tx, isMintparameter;
    const { data, isLoading: mintLoading, isError } = useWalletBalance({
      chain: network[networkIndex],
      address: account.address,
      client,
    });

    if (isError) {
      sendMessage("Internet Error.", 5000);
    }

    if (data && !isMintparameter) {
      isMintparameter = true;
    tx = ethers.utils.formatEther(data.value.toString());
    setAccountBal(Number(tx)); 
    }      
  };

  const handleMintSession = () => {
    setMint(true);
    sendMessage('...thinking...', 5000);
    setRequest('');
  };

  const handleMint = async() => {
    if (!nameText) return;    
    // console.log('running Mint function...');
    const mintfee = await readContract({ 
      contract: contractBRAINS, 
      method: "function fee() view returns (uint256)", 
      params: [] 
    });

    const mintValues = {mintFee: mintfee, nameText: nameText};
    setMintValues(mintValues);
    Mint(mintfee, mintValues.nameText);
  }
  

  async function Mint(_mintfee, _name) {
    try {
      let mintfee, brainfee, accbal, approval; 
    
        mintfee = Number(ethers.utils.formatEther(_mintfee?.toString()));
        
        // console.log('Called Mint fee...', mintfee);
    
        // check if user can mint a Battledog
        if (accountBal < mintfee) {
          sendMessage("Insufficient Funds to Mint.", 5000);
          return;
        }
        
        // console.log('Checking Account Bal from...', mintfee);
        
        const call2 = await readContract({
          contract: contractBrain,
          method: "function balanceOf(address account) view returns (uint256)", 
          params: [account.address]
        });

        accbal = Number(ethers.utils.formatEther(call2?.toString()));
      
        const call3 = await readContract({ 
          contract: contractBRAINS, 
          method: "function brainFee() view returns (uint256)", 
          params: [] 
        });
        
        brainfee = Number(ethers.utils.formatEther(call3?.toString()));
    
      if (accbal < brainfee) {
        sendMessage("Insufficient Brains.", 5000);
        return;
      }

      sendMessage("Analyzing brain approval...", 5000);

        const call4 = await readContract({
          contract: contractBrain,
          method: "function allowance(address owner, address spender) view returns (uint256)",
          params: [account.address, brainNFTAddress]
        });

        approval = Number(ethers.utils.formatEther(call4?.toString()));

      if (call4 < call3) {
        setIsApproving(true);
        sendMessage("Requesting necessary approval...", 5000);
        const transaction1 = prepareContractCall({
          contract: contractBrain,
          method: "function approve(address spender, uint256 value) returns (bool)",
          params: [brainNFTAddress, call3]
        });

        sendTransaction(transaction1);
      } else {
        mintBrain(_mintfee, _name);
      }

    } catch (error) {
      console.log('error calling allowance: ', error);
    }

  }

  function LoadingDock() {
    return (
      <>
        {submitText || "Thinking..."}
      </>
    );
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    setRequest(value);

    // Clear the previous timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // If input is not empty, set a new timeout
    if (value.trim() !== '') {      
      const newTimeout = setTimeout(() => {
        handleSession();
      }, 5000);  
      setTypingTimeout(newTimeout);
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setNameText(value);

    // Clear the previous timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // If input is not empty, set a new timeout
    if (value.trim() !== '') {    
      const newTimeout = setTimeout(() => {
        handleMint();
      }, 5000);  
      setTypingTimeout(newTimeout);
    }
  };

  function SelectedRobot() {
    return (
      <div className="robot-selection">
        <img src={currentBody} className="robot bodies" />
        {currentSticker && (
          <img src={currentSticker} className="robot stickers" />
        )}
        {currentGlasses && (
          <img src={currentGlasses} className="robot glasses" />
        )}
        {currentHat && (
          <img src={currentHat} className="robot-hat" />
        )}
      </div>
    );
  }

  let randomIndex;
  useEffect(() => {
    if (mint) {
      randomIndex = fisherYatesShuffle(bodies.length);
      setCurrentBody(bodies[randomIndex]);
    }    
  },[mint]);

  useEffect(() => {
    if (mint && isApproving && transactionResult) {
      if (isMint) return;
      isMint = true;
        setIsApproving(false);
        sendMessage('Approval Success.', 5000);
        mintBrain(mintValues.mintFee, mintValues.nameText);
      isMint = false;
    } else if (mint && isMinting && transactionResult) {
      if (isMint) return;
      isMint = true;
        setIsMinting(false);
        setMint(false);
        sendMessage('Mint Success.', 5000);
        setNameText('');
        runDelayMessage();
      isMint = false;
    } else if (isWriting && transactionResult) {
      if (isMint) return;       
        fetchPreviousDialogue(); 
        setCounter(0);   
        setConversations([]);
        hideLikes();
        setIsWriting(false);
      isMint = false;
    }
  },[transactionResult]);

  useEffect(() => {
    if (mint && isApproving && txError) {
      if (isMint) return;
      isMint = true;
      setIsApproving(false);
        sendMessage('Approval Failed. Try again.', 5000);
      isMint = false;
    } else if (mint && isMinting && txError) {
      if (isMint) return;
      isMint = true;
        setMint(false);
        setIsMinting(false);
        sendMessage('Mint Failed.', 5000);
      isMint = false;
    } else if (isWriting && txError) {
      if (isMint) return;
      isMint = true;
        setIsWriting(false);
        sendMessage('Error sending conversation. Try again.', 5000);
      isMint = false;
    }
  },[txError]);

  const handleNumb3rs1 = () => {
    sendMessage('...retrieving PIA Insight', 5000);
      setBackgroundImage(responseBackground.OutlayInsight);
      setBackgroundImageMobile(responseBackground.OutlayInsightMobile);
      if (viewHistory) {
        setStream(historicalDialogue.insight);
      } else {
        setStream(response.insight);
      }
  }

  const handleNumb3rs2 = () => {
    sendMessage('...retrieving useful Contacts', 5000);
      setBackgroundImage(responseBackground.OutlayContacts);
      setBackgroundImageMobile(responseBackground.OutlayContactsMobile);
      if (viewHistory) {
        setStream(historicalDialogue.contacts);
      } else {
        setStream(response.contacts);
      }
  }

  const handleNumb3rs3 = () => {
    sendMessage('...retrieving PIA Disclaimer', 5000);
      setBackgroundImage(responseBackground.OutlayMisc);
      setBackgroundImageMobile(responseBackground.OutlayMiscMobile);
      if (viewHistory) {
        setStream(historicalDialogue.disclaimer);
      } else {
        setStream(response.disclaimer);
      }
  }

  const handleNumb3rs4 = () => {
    sendMessage('...retrieving Actionable Intelligence', 5000);
      setBackgroundImage(responseBackground.OutlayList);
      setBackgroundImageMobile(responseBackground.OutlayListMobile);
      if (viewHistory) {
        setStream(historicalDialogue.list);
      } else {
        setStream(response.list);
      }
  }

  const handleNumb3rs5 = () => {
    sendMessage('...retrieving helpful advice', 5000);
      setBackgroundImage(responseBackground.OutlayAdvice);
      setBackgroundImageMobile(responseBackground.OutlayAdviceMobile);
      if (viewHistory) {
        setStream(historicalDialogue.advice);
      } else {
        setStream(response.advice);
      }
  }

  const handleNumb3rs6 = () => {
    sendMessage('...retrieving PIA', 5000);
      setBackgroundImage(responseBackground.OutlayActions);
      setBackgroundImageMobile(responseBackground.OutlayActionsMobile);
      if (viewHistory) {
        setStream(historicalDialogue.actions);
      } else {
        setStream(response.actions);
      }
  }

  const closeResponse = () => {
    setRequest('');
    setResponse(null);
    setCurrentResponse(null);
    setAssistance(null);
  }

  const closeHistoria = () => {
    setViewHistory(false);
    setRequest('');
    setResponse(null);
    setCurrentResponse(null);
    setLoading(false);
    setMint(false);
  }

  const progressBarStyle = () => {
    let progressBar, countMultiplier = counter * 5;
    if (counter > 20) {
      progressBar = {width: `${Math.min(countMultiplier, 99)}vw`, borderLeft: '0px', boxShadow: `0 0 10px 5px rgba(255, 105, 180, 0.7)`}
    } else {
      progressBar = {width: `${Math.min(countMultiplier, 99)}vw`}
    }
    return progressBar;
  }

  // useEffect(() => {
  //   preloadImages([backgroundImage]);
  // }, []);

  useEffect(() => {
    const fetchParams = async() => {
      try {
        const response = await fetch(`https://daemon.brainonsonic.xyz/assets/docs/log.json`, {
          method: "GET",
        });

        if (!response.ok) throw new Error("Network response was not ok");

        const log = await response.json();

        const params =  log.params[0];
        const newParams = {desktopMax: params.desktopMax, mobileMax: params.mobileMax, delay_const: params.delay_const, maxDialogueReads: params.maxDialogueReads}
        setParameters(newParams);
        
      } catch (error) {
        console.error('Error setting new params:', error);
      }
    }
    fetchParams();
  },[]);

  useEffect(() => {
    if (stream) {
      setIsPrepping(true);
      setTimeout(() => {
        setIsPrepping(false);
      },4100)
    }
  },[stream]);

  useEffect(() => {
    resetState();
    if (account) {
      const quickSearch = async() => {
        const call = await fetchBrainNFT();
      }
      quickSearch();
    }
  }, [account, blockchain.chainId]);

  useEffect(() => {
    if (response) {
      if (isResponse) return;
      isResponse = true;
      // initialize or increment counter
      if (counter === null) {setCounter(1);} else {setCounter(counter + 1);}
      setPutter(false);
      put = false;
      
      setTimeout(() => {        
        setLike(true);
      }, 25000);
      isResponse = false;
    }
  },[response]);

  useEffect(() => {
    if (currentNFT && !dialogues) {
      if (isReading) return;
      isReading = true;
      sendMessage('Retrieving history...', 5000);
      setMintLog(true);
      // Call previous data to get history
      fetchPreviousDialogue();
      isReading = false;
    }
  },[currentNFT]);

  useEffect(() => {
    if (request && currentNFT > 0 && dialogues && history !== null  && trigger) {
      // Submit previous data as assistance
      runQuery();
    }    
  },[trigger]);

  useEffect(() => {
      if (isIndexed || !dialogues) return;
      isIndexed = true;
      const parser = async () => {  
        // console.log('Parsing dialogue...');      
        const parsedDialogue = await parseResponse(dialogues[historyIndex]);  
        setHistoricalDialogue(parsedDialogue);
        setStream(parsedDialogue.insight); 
      }
      parser();
      isIndexed = false;
  },[dialogues, historyIndex]);

  useEffect(() => {
    if (assistance) {
      if (modeSelect.perplexity === 1) {
        perplexityAI(assistance);
      } else if (modeSelect.deepseek === 1) {
        deepseekAI(assistance);
      } else if (modeSelect.openai === 1) {
        openAI(assistance);
      } else if (modeSelect.anthropic === 1) {
        anthropicAI(assistance);
      } 
    }
  },[assistance, modeSelect]);

  useEffect(() => {
    let total = stickers.length
    const intervalId = setInterval(() => {
      setNumb3rs({
        first: fisherYatesShuffle(total),
        second: fisherYatesShuffle(total),
        third: fisherYatesShuffle(total),
        fourth: fisherYatesShuffle(total),
        fifth: fisherYatesShuffle(total),
        sixth: fisherYatesShuffle(total),
        seventh: fisherYatesShuffle(total),
        eighth: fisherYatesShuffle(total),
        ninth: fisherYatesShuffle(total),
        last: fisherYatesShuffle(total)
      });
    }, 3000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [stickers.length]);

  return (
    <>
    <ReactPlayer
        url={soundEffectUrl}
        playing={isEffectPlaying}
        volume={volumeLevel}
        onEnded={stopSoundEffect} 
        style={{ display: 'none' }}
        controls={false}
      />

    <div className="blueblur" />
    <div className={`response-progress-bar clickability${isWriting}`} disabled={isWriting ? 1 : 0} style={progressBarStyle()} onClick={submitEventHistory} title="Click to submit your conversations onchain"> <TiWarning /> Submit your conversations onchain <TiWarning /> </div>
    {response && 
    <>
      <Desktop>      
        <div className="response-container" style={responderBackground}>
          {responder()}
        </div>
      </Desktop>
      <Mobile>    
        <div className="response-container" style={responderMobileBackground}>
          {responder()}
        </div>
      </Mobile>
    </>
    }
    {response === null &&
    <>
      <MintParameter /> 
        {mintLog && (
            <div className="notification">
              <span className="title waveanimator liner1">Session Activated. </span>
              <span className="subtitle waveanimator class2">Token {mintLog.tokenId} minted by {truncateAddress(account.address)}</span>
            </div>
        )}  
        <div className="PIA">
        DATA INSIGHTS <br />
        </div> 
        <div className="PIA-subtitle">precise, intelligent, autonomous.</div>
        {loading ? (
          <div className="brain-placeholder centerMass">
            <LoadingDock />
          </div>
        ) : (
          <>
          <div className="dateTitle" onClick={handleViewHistory}>View History</div>
            {!mint ? 
              <>
                <div className="title waveanimator class2 switchtitle">{currentModule}</div> <br />
                {modeSelector()}<br />
                <div className="title waveanimator class2 switchsubtitle">fallback: {arrangeFallback()}</div>
                <textarea
                  ref={textareaRef} 
                  className="inputbox"
                  value={request}
                  onChange={handleInputChange}
                  placeholder="Ask the B.R.A.I.N..."
                  rows={1} // single row
                />
              </>
              :
              <>
                {(!isApproving || !isMinting) && 
                <div >
                  <img src={currentBody} className="robot" alt="robot"/>
                  <br />            
                  <input 
                    className="mintInput" 
                    value={nameText}
                    onChange={handleNameChange}
                    placeholder={"Name your Robot...[Costs 10k Brains] 🔥"}
                  />
                </div>              
                }
              </>
            }
          </>
        )}
      </>
    }
    {!response && esthetics && loading &&
      <div className="brain-placeholder centerMass">
        <LoadingDock />
      </div>
    }
    {!response && esthetics && submitText &&
      <div className="title waveanimator centerMass">
        {submitText}
      </div>
    }
    {viewHistory && dialogues && dialogues.length > 0 ? 
    <>
      <Desktop>      
        <div className="response-container" style={responderBackground}>
          {historia()}
        </div>
      </Desktop>
      <Mobile>    
        <div className="response-container" style={responderMobileBackground}>
          {historia()}
        </div>
      </Mobile>
    </>
    : viewHistory && dialogues && dialogues.length === 0 ?
    <>         
      <HiOutlineX className="responder-close-button" onClick={closeHistoria} style={{color: 'lime', borderColor: 'lime'}}/>
      <div className="brain-placeholder centerMass">
        No history to see.
      </div>
    </>
    : null
    }
    </>
  );
}

export default Robot;